import Backbone from "backbone";
import $ from "jquery";

export default Backbone.View.extend({
  initialize: function () {
    $(window).scroll(this.detectScroll);
  },

  detectScroll: function () {
    var checkHauteur = $(".js-contentMenu").height();
    if ($(window).scrollTop() > checkHauteur) {
      $(".js-SearchSideAdvertising").addClass("adStick");
    }
    else {
      $(".js-SearchSideAdvertising").removeClass("adStick");
    }
  }

});
